import React, { useState } from "react";
import OrderTable from "./OrderScreenComponents/OrderTable";
import { ArrowRight, CircleCheck } from "lucide-react";
import DetailTable from "./DetailTable";
import { NavLink } from "react-router-dom";

const AcceptTableScreen = () => {
  return (
    <div className=" bg-white ml-[2.083333vw] mt-[3.5185vh] mr-[2.638888vw] pb-5">
      <div className="flex flex-row box-border h-[8.7vh] w-[100]">
        <div className="w-[70%] box-border flex items-center px-[3.220338983%] justify-start text-[22px] font-medium font-outfit">
          Order Details
        </div>
        <NavLink
          to={-1}
          className="w-[30%]  box-border flex items-center px-[3.220338983%] justify-end  ">
          {" "}
          <button className="border-[2px] border-[#5652B0] text-[#5652B0] text-[15px] font-medium font-outfit flex flex-row gap-x-2 p-1 rounded-lg">
            {" "}
            <img
              src={require("../../../../assets/edit.png")}
              alt="Edit Icon"
            />{" "}
            Edit table
          </button>
        </NavLink>
      </div>

      <hr />

      <DetailTable />

      <div className="flex flex-row border border-[#BEBEBE] mx-auto rounded-sm w-[97%] mt-5 ">
        <p className="w-[30%] font-outfit font-medium border-r-2 border-black p-2">
          Grand Total
        </p>{" "}
        <p className="p-2 flex items-end justify-end w-[66%] font-outfit">
          <span className="font-outfit font-medium"></span>34,099
        </p>
      </div>
    </div>
  );
};

export default AcceptTableScreen;
